import React, { Component } from "react";
import { Box, Button, Container, Typography } from "@mui/material";

export function RouteLoading() {
  return (
    <Container component="main" sx={{ minHeight: "60vh", py: 8 }}>
      <Typography role="status">Chargement de la page…</Typography>
    </Container>
  );
}

export default class RouteBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Container component="main" sx={{ minHeight: "60vh", py: 8 }}>
        <Box role="alert">
          <Typography component="h1" variant="h4" sx={{ mb: 2 }}>
            Impossible de charger cette page
          </Typography>
          <Typography sx={{ mb: 3 }}>
            Vérifiez votre connexion, puis réessayez.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Réessayer
          </Button>
        </Box>
      </Container>
    );
  }
}
